import { useContext } from 'react'

import {
  MatchDataReturns,
  MatchDataContext,
} from '@talentinc/gatsby-theme-ecom/components/Providers/MatchData'

export default function useMatchData(): MatchDataReturns {
  return useContext(MatchDataContext)
}
